// ItemGlyph.js — an item's icon at any size: the built-in's own icon, the
// vendor's icon, or (for an app that registered none) its brand-coloured initial.
import WorkspaceIcon from './WorkspaceIcon';
import { GRADE_TEXT_COLORS, gradeForScore } from 'components/Misc/complianceGrades';

/** App icon (or brand monogram) at tab-label size. */
export default function ItemGlyph({ item, size = 16, style }) {
  if (item.kind === 'builtin') return <WorkspaceIcon id={item.id} size={size} style={style} />;
  if (item.icon) return <img src={item.icon} alt="" width={size} height={size} style={{ objectFit: 'cover', borderRadius: size / 4, display: 'block', ...style }} />;
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: size / 4,
        background: item.color,
        color: '#fff',
        fontSize: size * 0.62,
        fontWeight: 700,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      {(item.label || '?').slice(0, 1).toUpperCase()}
    </span>
  );
}


/**
 * The Compliance tab's compact face: its grade letter in the tab's own grade
 * colours (same thresholds as the full title), or the icon while there is no
 * grade. null lets the tab fall back to its icon.
 */
export function complianceCompactTitle(score, loading) {
  if (loading) return <i className="fa fa-spinner fa-spin" style={{ fontSize: 16 }} />;
  if (!score) return null;
  const letter = gradeForScore(score);
  const color = GRADE_TEXT_COLORS[letter];
  return <span style={{ fontWeight: 700, fontSize: '1.15rem', lineHeight: 1, color }}>{letter}</span>;
}
